import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BadgePrint from "./BadgePrint";
import { BadgeViewModel, GetBadge } from "./BadgeStore";

const BadgeRedemptionSetup = () => {
    const [badge, setBadge] = useState({} as BadgeViewModel);
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        if (id) {
            GetBadge(id).then((response) => {
                setBadge(response.result);
            });
        }
    }, [id]);

    return (
        <>
            <BadgePrint badges={badge.blanks} />
        </>
    );
};

export default BadgeRedemptionSetup;
